<script lang="ts">
    import {getFormatter} from "../../utils";

    export let subtotal: number;
    export let zIndex: boolean;
    let formatter = getFormatter();

    export let label = 'Continuar';

</script>

<section class="subtotal" class:zhide={zIndex}>
    <div class="container  max-w-900px m:mx-auto">
        <div class="">
            <div class="w-100 m:box-b">
                <div class="pt-1  m:pt-0">
                    <strong>Subtotal de tu compra</strong>
                    <h3>{formatter(subtotal)}</h3>
                </div>
                <div class="py-1">
                    <div class="btn accent min-w-100 text-c" on:click>{label}</div>
                </div>
            </div>
        </div>
    </div>
</section>
<style>
    .subtotal {
        position: sticky;
        background: white;
        bottom: 0;
        box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.1);
        z-index: 10;
    }

    .subtotal.zhide {
        z-index: 5;
    }
</style>